/* eslint-disable react/jsx-props-no-spreading */
import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import ArrowDown from '../../icons/arrow-down.svg';

const DesktopLinkGroup = (props) => {
  const { to, href, label, children, mode, className } = props;

  let linkProps = { to };

  if (href) {
    linkProps = { href, target: '_blank', rel: 'noreferrer', as: 'a' };
  }

  if (!children) {
    return (
      <Wrapper className={className}>
        <StyledLink {...linkProps} mode={mode}>
          {label}
        </StyledLink>
      </Wrapper>
    );
  }

  return (
    <Wrapper className={className} aria-haspopup="true">
      <StyledLink {...linkProps} mode={mode}>
        {label}
        <StyledArrowDown />
      </StyledLink>
      <DropdownWrapper aria-label="submenu">{children}</DropdownWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  padding: 15px 0;
`;

const StyledLink = styled(Link)`
  appearance: none;
  background-color: transparent;
  color: ${({ mode }) => (mode === 'light' ? 'rgb(10, 17, 44)' : '#ffffff')};
  padding: 0;
  border: none;
  text-decoration: none;
  margin: 0 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  height: 25px;
`;

const DropdownWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 100%;
  background: white;
  border-radius: 8px;
  padding: 5px;
  border: 1px solid rgb(220, 223, 232);
  box-shadow: 1px 1px 8px rgba(7, 32, 128, 0.15);
  display: flex;
  align-items: start;
  transition: all 0.1s linear;
  transform: translateY(-5px);

  opacity: 0;
  z-index: -100;
  pointer-events: none;

  ${Wrapper}:hover &, ${Wrapper}:focus-within & {
    transform: translateY(0);
    opacity: 1;
    z-index: 1;
    pointer-events: initial;
  }
`;

const StyledArrowDown = styled(ArrowDown)`
  margin-left: 10px;
`;

export default DesktopLinkGroup;
